import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Fields,
  MassActionRequest,
  MutationCreateMassActionRequestArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateMassActionRequest = (options?: {
  fields?: Fields.MassActionRequestFields
  useMutationOptions?: UseMutationOptions<
    MassActionRequest,
    ClientError,
    MutationCreateMassActionRequestArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    MassActionRequest,
    ClientError,
    MutationCreateMassActionRequestArgs
  >(
    variables =>
      client.mutation({
        name: 'createMassActionRequest',
        args: {
          fields,
          variables,
        },
      }),
    useMutationOptions,
  )
}
